import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { InputText } from '@companycam/slab-web';

// #region styled-components
const Container = styled.div`
  color: var(--cc_color_text_nonessential);
  padding: 8px;
  display: flex;
  align-items: center;
`;
// #endregion

const SearchInput = ({ id, label, placeholder, value, onChange }) => (
  <Container>
    <InputText
      type="search"
      name="queryTerm"
      id={id}
      hideLabel
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      showDefaultTextColor={!!value}
    />
  </Container>
);

SearchInput.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default SearchInput;
